export default __webpack_public_path__ + "static/media/Elton-Tsang.d4e26869.png";